import { ActionType } from "typesafe-actions";

import * as actions from "./actions";

export type CurrenciesAction = ActionType<typeof actions>;

export enum CurrenciesActionTypes {
  SELECT = "@Currencies/SELECT",
  FETCH_LOCAL_STORAGE = "@Currencies/FETCH_LOCAL_STORAGE",
}

export const defaultCurrency = "RUB";

export interface CurrenciesState {
  readonly selectedCurrency: string;
}

export interface CurrencyPayload {
  currency?: string;
}
